export default __webpack_public_path__ + "static/media/florDeArena.56210def.jpeg";